export default "__VITE_ASSET__BfqJL$vf__"